/**
 * @file index.js
 * @desc 代理商-成员管理
 */

import bendsdk from '@baidu/bend-plugin-sdk';

const routes = [
    {
        path: '/agentMemberManage',
        name: 'agentMemberManage',
        meta: {auth: 'in'},
        component: () => import('./views/index.vue')
    }
];

// 如果有权限控制的话，这里得引入SDK判断权限是否可以调用本插件，或者重插件配置页面读取插件信息
export default class agentMemberManage extends bendsdk.plugin {
    onInstall(router) {
        Array.prototype.push.apply(router.options.routes, routes);
        router.addRoutes(routes);
    }
}
